module.exports = __webpack_public_path__ + "static/img/bestsellheader.041d960.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bestsellheader.png
// module id = GQ/f
// module chunks = 1